
import { validationMixin } from "vuelidate";
import { SistemaMixin } from "@/modules/Application";
import { PessoaMixin } from "@/modules/Application";
import ContaReceberData, { ContaReceberDataRequired } from "./ContaReceberData";
import { Money } from "v-money";
import { MONEY as settingMoney } from "@/modules/Application";
import VueSelect from "vue-select";
import loadsh from "loadsh";
import "vue-select/dist/vue-select.css";
import { mapGetters } from "vuex";
import TableApp from "@/components/Table/Table3.vue";
import InformationOutline from "vue-material-design-icons/InformationOutline.vue";

export default {
  name: "app-contaReceber-form",
  props: {
    url: {
      type: String,
    },
    conta: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    Money,
    VueSelect,
    TableApp,
    InformationOutline,
  },
  mixins: [validationMixin, SistemaMixin, PessoaMixin],
  watch: {
    conta(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.form = newValue;
        this.form.valor = this.numberToReal(newValue.valor, 2);
        this.form.valor_total = this.numberToReal(newValue.valor_total, 2);
        this.form.juros = this.numberToReal(newValue.juros, 2);
        this.form.multa = this.numberToReal(newValue.multa, 2);
      }
    },
  },
  data() {
    return {
      tabIndex: 0,
      configMoney: settingMoney,
      form: {},
      novoComprovante: null,
      enviandoComprovante: false,
      vencimentoSelected: null,
      plano_contas: [],
      cliente: null,
      plano: null,
      pagamentoEditado: 0,
      clientes: [],
      meiosDePagamento: [],
      meiosPagamentoFetched: [],
      selectedPagamento: null,
      indexVencimento: null,
      meioPagamento: null,
      bancos: [
        {
          id_banco: 99999,
          nome: "Movimento Caixa",
        },
      ],
      fields: [
        {
          label: "",
          field: "id",
          slot: true,
          width: "10%",
          sortable: false,
        },
        {
          label: "Valor R$",
          field: "valor",
          slot: true,
          width: "45%",
          sortable: false,
        },
        {
          label: "Vencimento",
          field: "vencimento",
          slot: true,
          sortable: false,
          width: "45%",
        },
      ],
    };
  },
  validations: {
    form: ContaReceberDataRequired,
  },
  computed: {
    ...mapGetters(["itsblocked"]),
    valorPagamento() {
      if (!this.form?.parcelas) return;
      if (this.form.parcelas.length === 0) return 0;
      else return this.form.parcelas[0].valor;
    },
    isNotEdit() {
      return JSON.stringify(this.$route.params) === "{}";
    },
    valor_total() {
      return (
        this.form.valor + this.form.juros + this.form.multa - this.form.desconto
      );
    },
  },
  created() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
    this.getDataInit();
  },
  methods: {
    async anexarComprovante() {
      if (!this.novoComprovante) return;
      if (!["application/pdf", "image/jpeg", "image/png"].includes(this.novoComprovante.type) ||
          this.novoComprovante.size > 10 * 1024 * 1024) {
        this.$toast.error("Selecione PDF, JPG/JPEG ou PNG de até 10 MB.");
        return;
      }
      const payload = new FormData();
      payload.append("id_conta_receber", this.form.id);
      payload.append("comprovante_pagamento", this.novoComprovante);
      this.enviandoComprovante = true;
      try {
        const { data } = await this.$http.post("/contareceber/comprovantes/anexar", payload);
        this.$set(this.form, "comprovantes", data.data);
        this.novoComprovante = null;
        this.$toast.success("Comprovante anexado.");
      } catch (error) {
        this.$toast.error("Não foi possível anexar o comprovante.");
      } finally {
        this.enviandoComprovante = false;
      }
    },
    async removerComprovante(anexo) {
      try {
        await this.$http.post("/contareceber/comprovantes/remover", {
          id_conta_receber: this.form.id,
          id_comprovante: anexo.id,
        });
        this.$set(this.form, "comprovantes", this.form.comprovantes.filter((item) => item.id !== anexo.id));
        this.$toast.success("Comprovante removido.");
      } catch (error) {
        this.$toast.error("Não foi possível remover o comprovante.");
      }
    },
    async visualizarComprovante(anexo) {
      const janela = window.open("", "_blank");
      try {
        const resposta = await this.$http.get("/contareceber/comprovantes/visualizar", {
          params: { id_conta_receber: this.form.id, id_comprovante: anexo.id },
          responseType: "blob",
        });
        const tipo = resposta.headers["content-type"] || resposta.data.type || "application/pdf";
        const url = URL.createObjectURL(new Blob([resposta.data], { type: tipo }));
        if (janela) janela.location.href = url;
        else window.open(url, "_blank");
        setTimeout(() => URL.revokeObjectURL(url), 60000);
      } catch (error) {
        if (janela) janela.close();
        this.$toast.error("Não foi possível abrir o comprovante.");
      }
    },
    setAtivo() {
      this.form.recebido = this.form.recebido ? false : true;
    },
    setRepetir() {
      this.form.repetir = this.form.repetir ? false : true;
    },
    changePagamento(pagamentoIndex) {
      this.selectedPagamento = pagamentoIndex;
    },
    changePagamentoEdited(valor) {
      this.pagamentoEditado = valor;
    },
    salvarPagamento() {
      this.form.parcelas[this.selectedPagamento].valor = this.pagamentoEditado;
      this.$bvModal.hide("modal-pagamento");
    },
    selectVencimento(index) {
      this.indexVencimento = index;
    },
    salvarVencimento() {
      this.form.parcelas[this.indexVencimento].data_vencimento =
        this.vencimentoSelected;
      this.$bvModal.hide("modal-calendar");
    },
    gerarParcelas() {
      if (this.form.valor === 0) {
        this.$toast.error("Insira um valor para gerar parcelas!");
        return;
      }
      this.form.parcelas = this.defineParcelas(
        this.form.vezes,
        this.form.valor,
        this.form.data_vencimento
      );
    },
    setCliente(cliente) {
      this.cliente = cliente;
    },
    setPlano(plano) {
      this.plano = plano;
    },
    onSearchPlano(search, loading) {
      if (search.length) {
        loading(true);
        this.searchPlano(loading, search, this);
      }
    },
    searchPlano: loadsh.debounce(async (loading, search, vm) => {
      vm.plano_contas = await vm.getPlanoContasContaReceber(search);
      loading(false);
    }, 450),
    onSearch(search, loading) {
      if (search.length) {
        loading(true);
        this.search(loading, search, this);
      }
    },
    search: loadsh.debounce(async (loading, search, vm) => {
      vm.clientes = await vm.getPessoaNome(search);
      loading(false);
    }, 350),
    onSearchMeioPagamento(search) {
      this.meiosDePagamento = this.meiosPagamentoFetched.filter((pagamento) =>
        pagamento.descricao.toLowerCase().includes(search.toLowerCase())
      );
    },
    async getDataInit() {
      this.form = new ContaReceberData({});
      this.plano_contas = await this.getPlanoContasContaReceber();
      const bancos = await this.getBancosByEmpresa();

      const response = await this.$http.post("/financeiro/meios-pagamento");
      this.meiosDePagamento = response.data;
      this.meiosPagamentoFetched = this.meiosDePagamento;

      this.bancos.push(...bancos);

      if (this.conta.id) {
        this.form = this.conta;
        this.meioPagamento = this.conta.meio_pagamento;
        this.setCliente(this.conta.pessoa);
        this.setPlano(this.conta.plano_contas);
      }
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    async onSubmit() {
      const submitButton = this.$refs["submit_conta_novo"];

      try {
        this.$v.form.$touch();

        if (this.$v.form.$anyError) {
          this.$toast.error(
            "Verifique todos os campos obrigatórios do formulário!"
          );
          return;
        }

        submitButton.classList.add("spinner", "spinner-light", "spinner-right");
        submitButton.setAttribute("disabled", "");

        this.form.pessoa = this.cliente;
        this.form.id_plano_contas = this.plano?.id ?? null;

        if (this.valor_total) {
          this.form.valor_total = this.valor_total;
        }
        this.form.id_meio_pagamento = this.meioPagamento?.id ?? null;

        if (this.form.repetir) {
          if (!this.form.pessoa) {
            this.$toast.warning(
              "Para função de repetir parcelas é necessário informar cliente!"
            );
            submitButton.classList.remove(
              "spinner",
              "spinner-light",
              "spinner-right"
            );
            submitButton.removeAttribute("disabled", "");
            return;
          }
        }

        await this.$http.post(this.url, this.form);

        this.$router.push({ name: "contasReceber" });
      } catch (error) {
        submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );
        submitButton.removeAttribute("disabled", "");
      }
    },
  },
};
